import { GoodToKnowUI } from "./GoodToKnowUI";
import { StandardProps } from "../componentMap";
import { Product, Variant } from "../../types/types";
import { useVariant } from "../../hooks/useVariant/useVariant";

const EAN_NOT_FOUND = "EAN_NOT_FOUND";

function getEan(variant: Variant): string {
  const { consumerBarcodes } = variant;
  if (consumerBarcodes) {
    const { ean13 = [], upc12 = [], ean8 = [] } = consumerBarcodes;
    if (ean13.length === 0 && upc12.length === 0 && ean8.length === 0) {
      return EAN_NOT_FOUND;
    }
    return ean13[0] || upc12[0] || ean8[0] || EAN_NOT_FOUND;
  }
  return EAN_NOT_FOUND;
}

function isChanelProduct(product: Product): boolean {
  return product?.brand?.name === "CHANEL";
}

export function GoodToKnow({
  product,
  runtimeConfig,
}: Pick<StandardProps, "product" | "runtimeConfig">) {
  const { variant } = useVariant(product);
  if (!variant) return null;

  const ean = getEan(variant);
  const isChanel = isChanelProduct(product);
  const cleanBeautyBaseUrl = runtimeConfig?.cleanBeautyBaseUrl;

  return (
    ean !== EAN_NOT_FOUND &&
    !isChanel && (
      <GoodToKnowUI ean={ean} cleanBeautyBaseUrl={cleanBeautyBaseUrl} />
    )
  );
}
